module.exports = __webpack_public_path__ + "static/media/special-order.fb341722.svg";